import React, {useMemo} from "react";
import JobApplicationsDataTable from "./table/JobApplicationsDataTable";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {useSearchParams} from "react-router-dom";
import {searchParamsToStatusFilter} from "@widgets/jobApplications/overview/heading/JobApplicationStatusFilter";
import {JobApplicationsFilterStatus} from "@widgets/jobApplications/overview/JobApplications";
import JobApplicationsPageHeading from "@widgets/jobApplications/overview/heading/JobApplicationsPageHeading";

const JobApplicationsOverview = () => {
    const {dashboardLocation} = useRestaurant();
    const [searchParams, setSearchParams] = useSearchParams();
    const statusFilter: JobApplicationsFilterStatus = useMemo(
        () => searchParamsToStatusFilter(searchParams),
        [searchParams]);

    return (
        <>
            <JobApplicationsPageHeading
                statusFilter={statusFilter}
                setSearchParams={setSearchParams}
            />

            <div className={"mt-8 md:mt-16"}>
                <JobApplicationsDataTable
                    dashboardLocation={dashboardLocation.id}
                    statusFilter={statusFilter}
                />
            </div>
        </>
    );
};

export default JobApplicationsOverview;